// extracted by mini-css-extract-plugin
export default {"p":"_55d09cd792 _4c4d72f417 f666e7a19f","clr":"a5d56fa845","dls":"_3941ff9c01"};